export class AppErrorHandler{
    
    constructor(public error ?:any){
    
    }

}